import { getFileExtension } from "@/utils/files/file"
import { useIntl } from "react-intl"

const MAX_FILE_SIZE = 2 * 1024 * 1024 // 2 Mo. Check upload_max_filesize in php.ini
const VALID_FILE_EXT = ["zip", "pdf"]

export const useValidateFiles = () => {
  const intl = useIntl()

  const validateFiles = (newFiles: File[]) => {
    const errors: string[] = []
    newFiles.map(newFile => {
      if (newFile.size > MAX_FILE_SIZE) {
        errors.push(
          intl.formatMessage(
            { id: "attachment.fileSizeLimitError" },
            {
              fileName: newFile.name,
              maxFileSize: Math.round((MAX_FILE_SIZE / 1024 / 1024) * 100) / 100,
            }
          )
        )
      }

      if (
        !newFile.type.startsWith("image/") &&
        !VALID_FILE_EXT.includes(getFileExtension(newFile.name))
      )
        errors.push(
          intl.formatMessage({ id: "attachment.fileTypeError" }, { fileName: newFile.name })
        )
    })
    return errors.length > 0 ? errors : undefined
  }

  return { validateFiles }
}
